import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { dashboardFeatureKey, reducer } from './dashboard.reducer';
import { DashboardEffects } from './effects/dashboard.effects';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        StoreModule.forFeature(dashboardFeatureKey, reducer),
        EffectsModule.forFeature([DashboardEffects])
    ]
})
export class DashboardStoreModule {}
